/**
 * @generated SignedSource<<ffddf233415f059861c134c540bac118>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type teamMemberInvitationFragment$data = {
  readonly id: string;
  readonly externalRef: string;
  readonly accountId: string;
  readonly account: {
    readonly " $fragmentSpreads": FragmentRefs<"accountBaseFragment">;
  };
  readonly memberUserId: string | null;
  readonly memberUserProfile: {
    readonly " $fragmentSpreads": FragmentRefs<"teamMemberUserProfileFragment">;
  } | null;
  readonly email: string;
  readonly message: string | null;
  readonly accepted: boolean | null;
  readonly createdAt: any | null;
  readonly createdByUserProfile: {
    readonly " $fragmentSpreads": FragmentRefs<"teamMemberUserProfileFragment">;
  };
  readonly " $fragmentType": "teamMemberInvitationFragment";
};
export type teamMemberInvitationFragment$key = {
  readonly " $data"?: teamMemberInvitationFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"teamMemberInvitationFragment">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "args": null,
    "kind": "FragmentSpread",
    "name": "teamMemberUserProfileFragment"
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "teamMemberInvitationFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "externalRef",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "accountId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Account",
      "kind": "LinkedField",
      "name": "account",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "accountBaseFragment"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "memberUserId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "UserProfile",
      "kind": "LinkedField",
      "name": "memberUserProfile",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "accepted",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "UserProfile",
      "kind": "LinkedField",
      "name": "createdByUserProfile",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": null
    }
  ],
  "type": "TeamMemberInvitation",
  "abstractKey": null
};
})();

(node as any).hash = "399a59f4a30a8a03a0cede5f1171789f";

export default node;
